import { useState, useEffect, useCallback } from 'react';

import { PageLayout } from '@/components/pagelay';
import Link from 'next/link';

import styles from './styles.module.scss';
import cName from 'classnames';

import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import request from '@/utils/request';

export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);

  const { data: _data } = await request.get(`/getExhibitor`, {
    headers: {
      lang: context.locale || context.defaultLocale || 'cn',
    },
    params: {
      id: context.query.id,
    }
  })
  return {
    props: {
      ...res.props,
      data: _data?.data || null,
    }
  }
}

export default function Exhibitor({ menuDetail, data }) {
  console.log("数据", menuDetail, data);

  const router = useRouter()
  const t = useTranslations();

  const head = {
    meta_title: `${data?.company}-IPB国际粉体散料流体加工展览会|IPB上海粉体展|国际粉体展|IPB粉体展`,
    meta_kws: `${data?.company}，2027国际粉体展参展企业,IPB展商名单,粉体行业展商名录,第二十四届IPB粉体展展商，粉体设备企业参展名单，中国粉体展，粉体加工展，上海粉体展`,
    meta_desc: `IPB粉体展（国际粉体、散料、流体加工展览会）由纽伦堡会展（上海）有限公司和中国颗粒学会联合主办。面向行业：化工、新能源、食品、医药、陶瓷、塑料、半导体、粉体材料、金属粉体、非金属粉体、功能性粉体。展示产品范围：粉体加工设备、粉碎设备、研磨设备、过滤设备、分级设备、混合设备、干燥设备、粉体检测与分析仪器、粉体制备与合成、散料输送、物料处理、散料输送与储存、颗粒分析、颗粒表征、安全与环保、工业除尘、粉尘防爆、过程测量与控制技术，以及产学研相关服务。`,
  }

  return (
    <div>
      <PageLayout
        temp='page_crumb'
        crumb={[{
          path: router.locale === 'cn' ? router.asPath : '/en' + router.asPath,
          name: data?.company
        }]}
        partPath='/online/exhibitor'
      >
        <div className={styles.container}>
          {getHead(head)}
          <i className={styles.bg1}></i>
          <div className={cName(styles.content, 'm-1480')}>
            <div className={styles.top}>
              <div className={styles.cover}>
                <img src={data.logo || 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} alt={data.company} />
              </div>
              <div className={styles.info}>
                <p className={styles.company}>{data.company}</p>
                <p className={styles.country}>{data.country}</p>
                <p className={styles.booth}>{t('online.booth')} {data.booth_num}</p>
                <p className={styles.cate}>{t('online.cate')} {data.category_name}</p>
              </div>
            </div>
            <div className={styles.bottom}>
              <div className={styles.intro}>
                <h2>{t('online.companyProfile')}</h2>
                <p className={styles.content}>{data.content}</p>
                <h2>{t('online.companyProd')}</h2>
                <ul className={styles.list}>
                  {
                    data.product_list?.map((item: any, index: number) => (
                      <li key={index}>
                        <Link href={`/online/product/info?id=${item.id}`}>
                          <a className={styles.item}>
                            <div className={styles.cover}>
                              <img src={item.image || 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} alt={item.name} />
                            </div>
                            <p className={styles.name}>{item.name}</p>
                          </a>
                        </Link>
                      </li>
                    ))
                  }
                </ul>
              </div>
              <div className={styles.contact}>
                <h2>{t('online.contactUs')}</h2>

                <p className={styles.contacts}>{t('online.contact')}</p>
                <span>{t('online.liao')}</span>

                <p className={styles.email}>{t('online.email')}</p>
                <span>Kimberley.zhang@nm-china.com.cn</span>

                <p className={styles.phone}>{t('online.tel')}</p>
                <span>{router.locale === 'en' ? '+86 ' : ''}021-6036-1229</span>

                <p className={styles.address}>{t('online.address')}</p>
                <span>{t('online.site')}</span>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    </div>
  );
};
